import { h, Component } from 'preact';
import { loadData } from '../../lib/alerts';
import { configure } from '../../config';
import { DeviceVariance } from '@cube/blocks';
import { dismissedStorage } from '../../lib/storage';
import { Alert } from './alerts';

const storage = dismissedStorage();

export class Notifications extends Component {
	state = {
		dismissed: this.props.dismissed || storage.get()
	};

	update = () => {
		let { startContentServiceOrigin, streamClient, feed } = this.props,
			devData = (typeof this.props.loadData === 'function') && this.props.loadData,
			request = devData && devData(startContentServiceOrigin, streamClient) || loadData(startContentServiceOrigin, streamClient, feed);

		request.then(({ alerts }) => {
			alerts = (alerts && alerts.length > 0 ? alerts : this.state.alerts || []);

			let activeAlerts,
				{ dismissed } = this.state;

			if (alerts && alerts.length) {
				alerts.map( (alert) => {
					if (dismissed.indexOf(alert.metadata.id) === -1) {
						activeAlerts = true;
					}
				});
			}

			if (activeAlerts) {
				return this.setState({ alerts });
			}
		}).catch((e) => {
			console.warn(e);
		});
	};

	handleDismiss = (alert) => {
		let id = alert.metadata.id;
		this.props.onDismiss && this.props.onDismiss({ id });
		storage.set(id);
		this.setState({ dismissed: storage.get() });
	}

	componentWillMount () {
		this.update();
		if (!this.props.disable_updates) {
			this.interval = setInterval(this.update, this.props.alertRefreshRate);
		}
	}

	componentWillUnmount() {
		clearInterval(this.interval);
	}

	render (props, { alerts, dismissed }) {
		return (
			<div>
				<DisplayAlerts
					alerts={alerts}
					onDismiss={this.handleDismiss}
					dismissed={dismissed}
					maxAlerts={props.maxAlerts}
					layout={props.layout}
					alertsText={props.alertsText}
					displayMode={props.displayMode}
					alertClass={props.alertClass}
				/>
			</div>
		);
	}
}

export default (configure({
	alertRefreshRate: 'notificationsConfig.alertRefreshRate',
	maxAlerts: 'notificationsConfig.maxAlerts',
	startContentServiceOrigin: 'notificationsConfig.startContentServiceOrigin',
	streamClient: 'streamClient',
	alertsText: 'notificationsConfig.alertsText',
	feed: 'notificationsConfig.feed'
})((props) =>  (
	<DeviceVariance
		phone={<Notifications {...props} layout="phone" />}
		tablet={<Notifications {...props} layout="tablet" />}
		desktop={<Notifications {...props} layout="desktop" />}
		desktopLarge={<Notifications {...props} layout="desktop" />}
		adaptive
	/>)));

export const DisplayAlerts = ({ alerts, dismissed, maxAlerts, layout, ...props }) =>
	alerts && alerts.length ? (
		<div data-tb-region={`notifications_alert_${layout}`}>
			{alerts.reduce((acc, alert) => {
				acc.length < maxAlerts &&
				dismissed.indexOf(alert.metadata.id) === -1 &&
				acc.push(
					<Alert
						alert={alert}
						layout={layout}
						{...props}
					/>
				);
				return acc;
			}, [])}
		</div>
	) : null;
